<template>
  <div class="news-d" v-if="newMsg">
    <div v-wechat-title="$route.meta.title=docTitle"></div>

    <div class="ex-box" v-if="exInfo" @click="$router.push(`/home/${exInfo.id}`)">
      <div class="ex-box-l" v-if="exInfo.logo">
        <img :src="exInfo.logo">
      </div>
      <div class="ex-box-r">
        <div class="txt1">{{exInfo.nameEn}}</div>
        <div class="txt2">
          {{exInfo.startData | moment("MMM D,YYYY")}} - {{exInfo.endDate | moment("MMM D,YYYY")}}
        </div>
      </div>
    </div>

    <h3>{{newMsg.title}}</h3>
    <p class="time">
      <span>{{newMsg.publishAt|| newMsg.createAt | moment('YYYY/MM/DD')}}</span>
      <span class="view">{{newMsg.viewCount}} views</span>
    </p>
    <p class="content" v-if="newMsg.content">summary：{{newMsg.content}}</p>
    <!-- 详情 -->
    <div class="comm_text" v-if="newMsg && newMsg.introduction">
      <div v-for="(item,index) in newMsg.introduction" :key="index">
        <!-- 文本 -->
        <p class="int-text" v-if="item.text" :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}" v-html="$service.replaceSpeace(item.text.content)"></p>
        <!-- 图片 -->
        <div class="int-img" v-if="item.picture && item.picture.type == 1" :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}">
          <div v-for="(itm,idx) in item.picture.list" :key="idx" :style="{'margin-bottom':item.picture.spacing+'px'}">
            <img :src="itm.url" preview="1" :preview-text="newMsg.Name" :large="itm.url" v-load="'oIntro'" style="width:100%;display: block" />
          </div>
        </div>
        <div class="comm_banner" style v-if="item.picture && item.picture.type == 2">
          <van-swipe class="my-swipe" v-if="newMsg" :autoplay="4000">
            <van-swipe-item v-for="(item, index) in item.picture.list" :key="'pic' + index">
              <img :src="item.url" preview="1" :preview-text="newMsg.Name" :large="item.url" style="width: 100%;height: 100%;display: block;" v-load="'oIntro'" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- 视频 -->
        <div class="int-video" v-if="item.video && item.video.link" style="position:relative;">
          <videoPlayer :url="item.video.link" :cover="item.video.cover" :time="item.video.time" :height="'3.5'"></videoPlayer>
        </div>
      </div>
    </div>

    <richContent v-if="newMsg && newMsg.content2" :info="newMsg.content2"></richContent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import videoPlayer from "../product-detail/videoPlayer";
import richContent from "@components/rich-content";
import gql from "graphql-tag";
export default {
  data () {
    return {
      newMsg: "",
      newContent: null,
      docTitle: "",
      exInfo: "",
    };
  },
  components: {
    videoPlayer,
    richContent,
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
    NewsGql () {
      return gql`
        query article($articleId: Long!) {
          article(articleId: $articleId) {
            articleType
            author
            content
            content2
            covers
            createAt
            favoriteCount
            id
            introduction
            likeCount
						publishAt
						itemId
            shareCount
            subtitle
            title
            updateAt
            userCount
            viewCount
          }
        }
      `;
    },
  },
  created () {
    this.$Myapollo.addExhibitionView();
    this.getNew();
  },
  mounted: function () {
    //图片查看器打开后，打印本次查看器的实例（事件、方法、属性的示例）
    this.$preview.on("imageLoadComplete", (e, item) => { });
  },
  methods: {
    ...mapActions({
      shareToWechat: 'wxShare/shareToWechat',
      addNewsView: 'follower/addNewsView',
      LinkToError: 'linkTo/LinkToError',
      getExhibitionInfoAndReturn: "getExhibitionInfoAndReturn",
    }),
    async addView () {
      await this.$Myapollo.getUserInfo(this);
      // console.log(this.userInfo,'userInfo');
      let body = {
        articleId: parseInt(this.$route.params.id),
        userId: this.userInfo.userId,
        nickName: this.userInfo.nickName || this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl
      };
      let res = await this.addNewsView(body);
      if (res.result) {
        this.newMsg.viewCount += 1;
      }
    },
    getNew () {
      this.$apollo.addSmartQuery("article", {
        query: this.NewsGql,
        variables: {
          articleId: parseInt(this.$route.params.id)
        },
        fetchPolicy: 'network-only',  // 清除缓存的数据，重新获取服务器数据
        result (res) {
          let data = JSON.parse(JSON.stringify(res));
          if (data && data.data.article) {
            let c = data.data.article;
            if (c.covers.indexOf('[') !== -1) {
              c.covers = JSON.parse(c.covers);
            } else {
              c.covers = [];
            }
            if (c.introduction && c.introduction.indexOf('[') !== -1) {
              c.introduction = JSON.parse(c.introduction);
            } else {
              c.introduction = [];
            }
            this.newMsg = c;
            this.docTitle = this.newMsg.title;
            this.$store.commit('setExhibitionId', c.itemId);
            this.addView();
            console.log(this.newMsg, 'this.newMsg');
            let text = '';
            let imgUrl = '';
            this.newMsg.introduction.forEach(e => {
              if (e.text) {
                text = e.text.content
              }
            })
            imgUrl = this.newMsg.covers[0];
            if (c.itemId) {
              this.getExInfo(c.itemId);
            }
            // 分享的配置
            const opt = {
              title: this.newMsg.title,
              desc: text,
              link: window.location.href,
              imgUrl: imgUrl
            };
            this.shareToWechat(opt);
          } else {
            this.LinkToError();
          }
          this.$previewRefresh();
        },
        error (error) {
          console.error(error, 'error错误处理')
        }
      })
    },
    async getExInfo (id) {
      this.exInfo = await this.getExhibitionInfoAndReturn(id);
      console.log('exInfo', this.exInfo);
    }
  },

}
</script>

<style scoped lang='scss'>
.news-d {
  // min-height: 100vh;
  background: #fff;
  padding: 15px;
  h3 {
    font-size: 0.4rem;
    font-weight: 600;
    line-height: 1.5;
    color: #222;
    padding-bottom: 0.3rem;
  }
  .time {
    display: flex;
    // justify-content: space-between;
    font-size: 0.26rem;
    color: #999;
    line-height: 1.2;
    // margin-bottom: .5rem;
  }
  .content {
    font-size: 14px;
    margin-top: 0.3rem;
    line-height: 1.5;
    // text-align: justify;
    word-break: break-all;
  }
  .view {
    display: flex;
    align-items: center;
    margin-left: 0.4rem;
  }
  .new-main {
    p {
      line-height: 1.5;
      font-size: 14px;
      color: #666;
      text-align: justify;
      margin-top: 10px;
    }
    .new-img {
      width: 100%;
      padding-top: 66%;
      margin-top: 10px;
      position: relative;
      img {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.comm_text {
  background: #fff;
  color: #333;
  padding: 0.35rem 0;
  margin-bottom: 0.2rem;
  > span {
    line-height: 1;
    padding: 0 0 0.2rem 0.3rem;
    font-size: 0.32rem;
    display: inline-block;
  }
  p {
    line-height: 0.48rem;
    font-size: 0.28rem;
  }
  img {
    display: block;
  }
  .int-text {
    padding: 0.3rem 0;
  }
}
.ex-box {
  margin-bottom: 0.3rem;
  height: 1.4rem;
  background-color: #f7f7f7;
  border-radius: 0.2rem;
  display: flex;
  padding: 0.2rem;
  &-l {
    width: 1.2rem;
    margin-right: 0.2rem;
    position: relative;
    img {
      width: 1.2rem;
      height: 100%;
    }
    &::before {
      content: "";
      width: 1px;
      height: 1rem;
      background: #e6e6e6;
      position: absolute;
      right: -0.2rem;
      top: 50%;
      margin-top: -0.5rem;
    }
  }
  &-r {
    font-size: 0.26rem;
    color: #1a1a1a;
    padding-left: 0.2rem;
    padding-right: 0.42rem;
    line-height: 1.4;
    margin-bottom: 0.1rem;
    .txt1 {
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 2; /** 显示的行数 **/
      overflow: hidden; /** 隐藏超出的内容 **/
      font-weight: bold;
      margin-bottom: 0.08rem;
      img {
        width: 0.24rem;
        height: 0.24rem;
        position: relative;
        top: 0.02rem;
        right: -0.02rem;
      }
    }
    .txt2 {
      font-size: 0.22rem;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 1px);
    }
    .s-blue {
      color: #1890ff;
      padding-left: 0.05rem;
      padding-right: 0.03rem;
      display: inline-block;
    }
  }
}
</style>
